import React, { PropsWithChildren, ReactNode } from 'react';

export interface FilterFieldProps {
  /** Rótulo em caixa-alta, acima do controle (ex.: "NOME DO ESTUDO"). */
  label: ReactNode;
  /** `id` do campo nativo que o rótulo nomeia: o rótulo vira `<label htmlFor>`. */
  htmlFor?: string;
  /** `id` do rótulo, para o controle se nomear por `aria-labelledby` (grupos e botões). */
  labelId?: string;
  className?: string;
}

/**
 * Campo da barra de filtros de Meus Estudos (#1995): rótulo azul em caixa-alta e o controle logo
 * abaixo (.dc.html:133-134). Os slots de Período (#1996) e Empresa (#2000) usam o mesmo campo
 * para ficar com o mesmo rótulo e o mesmo alinhamento.
 */
export default function FilterField({
  label,
  htmlFor,
  labelId,
  className = '',
  children,
}: PropsWithChildren<FilterFieldProps>) {
  return (
    <div className={['my-studies-filter-field', className].filter(Boolean).join(' ')}>
      {htmlFor ? (
        // O campo nomeado fica dentro de um componente (ex.: o input do Searcher do DS), ligado
        // pelo par htmlFor/id; a regra só reconhece o input aninhado direto no <label>
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label id={labelId} htmlFor={htmlFor} className="my-studies-filter-label">{label}</label>
      ) : (
        <span id={labelId} className="my-studies-filter-label">{label}</span>
      )}
      {children}
    </div>
  );
}
